module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_news_bg-bc4455861dc09fa37b1706b72d9f630a.png";